module.exports = __webpack_public_path__ + "img/album10_04.404b68fe.jpg";